export default __webpack_public_path__ + "8d083874089c5bec7a99bded67c5af7e.svg";